<h1 mat-dialog-title class="text-dark text-xl">
  {{ data.id ? 'Modifica Accesorio Veicolo' : 'Nuovo Accessorio Veicolo' }}
</h1>
<div mat-dialog-content class="w-full">
  <app-vehicle-accessory-form [data]="data"></app-vehicle-accessory-form>
</div>
